import {
	EDITIONS_GALLERY_DEFAULT_SORTS_ARTIST,
	EDITIONS_GALLERY_DEFAULT_SORTS_ASC,
	EDITIONS_GALLERY_DEFAULT_SORTS_DESC,
	EditionsGallerySort,
} from '#lib/websites/editions/constants/sorting.js';

export const getEditionsSortModifier = (sort: string) => {
	let sorts = [];

	if (sort === EditionsGallerySort.Newest) {
		sorts = EDITIONS_GALLERY_DEFAULT_SORTS_ASC;
	} else if (sort === EditionsGallerySort.Oldest) {
		sorts = EDITIONS_GALLERY_DEFAULT_SORTS_DESC;
	} else {
		sorts = EDITIONS_GALLERY_DEFAULT_SORTS_ARTIST;
	}

	return [sort, ...sorts];
};
